module.exports = "/home-mobile-frame-d54b251fc62510fcf02d80b19c832938.jpg";